import MulesoftFooter from './MulesoftFooter';

export default MulesoftFooter;
